import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import App from './App'
import router from './router'
import store from './store'
import $mConstData from '@/common/constData.js';
import $mFilter from '@/common/filter.js'
import { globalCommonMixin } from '@/common/globalCommonMixin'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import '@/styles/index.scss' // global css
import './assets/icon/iconfont.css'
import '@/icons' // icon
import '@/plugins/initCountData'
import '@/plugins/commonPlugin'
import '@/plugins/websocket'
import '@/permission' // permission control
import Lui from '@/lib/index.js'
import directive from './directive' //directive]
import warterMark from "./common/waterMark"
import $http from '@/utils/http'
Vue.prototype.$http = $http
// 全局导入过滤器
Object.keys($mFilter).forEach(key => Vue.filter(key, $mFilter[key]))
Vue.prototype.$mConstData = $mConstData;

Vue.use(ElementUI, {locale})
Vue.use(VCharts)
Vue.use(Lui)
Vue.mixin(globalCommonMixin)
Vue.use(directive)

Vue.config.productionTip = false
router.afterEach((item) =>{
  //warterMark.set("水印")
  if(item.name !== 'login'){    //判断是否为登录页面
    let name=store.getters.info.nickName
    let phoneNum=store.getters.info.phone||''
    let phone=phoneNum.length>4?phoneNum.substring((phoneNum.length-4),phoneNum.length):phoneNum
    console.log(store.getters.info, 'store.getters.name')
    warterMark.set(name+phone)
  }
})

new Vue({
  el: '#app',
  router, //router
  store, //vuex
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js